module.exports = __webpack_public_path__ + "img/hr-dirt-7.cf73dfd1.png";